/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoLinkedTaxAssessmentToShipmentInput = {
    clientMutationId?: string | null;
    slug: string;
    shipmentSlug: string;
};
export type SearchShipmentsMutationVariables = {
    input: infoLinkedTaxAssessmentToShipmentInput;
};
export type SearchShipmentsMutationResponse = {
    readonly infoLinkedTaxAssessmentToShipment: {
        readonly clientMutationId: string | null;
    } | null;
};
export type SearchShipmentsMutation = {
    readonly response: SearchShipmentsMutationResponse;
    readonly variables: SearchShipmentsMutationVariables;
};



/*
mutation SearchShipmentsMutation(
  $input: infoLinkedTaxAssessmentToShipmentInput!
) {
  infoLinkedTaxAssessmentToShipment(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoLinkedTaxAssessmentToShipmentPayload",
    "kind": "LinkedField",
    "name": "infoLinkedTaxAssessmentToShipment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchShipmentsMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SearchShipmentsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "15372a274d479a61aa254e1104abb466",
    "id": null,
    "metadata": {},
    "name": "SearchShipmentsMutation",
    "operationKind": "mutation",
    "text": "mutation SearchShipmentsMutation(\n  $input: infoLinkedTaxAssessmentToShipmentInput!\n) {\n  infoLinkedTaxAssessmentToShipment(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '4cfa2b3246fbbd2a763caeb074d07d93';
export default node;
